import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Gamepad2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0B0B15]/80 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="flex items-center justify-between" data-id="element-138">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-139">
            <div className="relative" data-id="element-140">
              <div className="absolute inset-0 bg-fuchsia-500 blur-lg opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-141" />
              <Gamepad2 className="h-8 w-8 text-fuchsia-400 relative z-10" data-id="element-142" />
            </div>
            <span className="text-2xl font-bold font-display bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400" data-id="element-143">
              Avatarise
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-144">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group" data-id="element-145">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-fuchsia-500 transition-all group-hover:w-full" data-id="element-146" />
              </a>)}
            <Button size="sm" variant="primary" data-id="element-147">
              Create Avatar
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-148">
            {isMobileMenuOpen ? <X data-id="element-149" /> : <Menu data-id="element-150" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-151">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0B0B15] border-b border-white/10" data-id="element-152">
            <div className="px-4 py-6 space-y-4" data-id="element-153">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block text-base font-medium text-gray-300 hover:text-white hover:pl-2 transition-all" onClick={() => setIsMobileMenuOpen(false)} data-id="element-154">
                  {link.name}
                </a>)}
              <Button className="w-full" variant="primary" data-id="element-155">
                Create Avatar
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}